/* "Load more" button: appends the next batch of products without leaving the page. */
(function () {
  'use strict';
  if (customElements.get('load-more')) return;

  class LoadMore extends HTMLElement {
    connectedCallback() {
      this.btn = this.querySelector('button');
      if (!this.btn) return;
      this.btn.addEventListener('click', () => this.load());
    }

    load() {
      var next = this.dataset.next;
      var target = document.querySelector(this.dataset.target);
      if (!next || !target || this.busy) return;
      this.busy = true;
      this.setAttribute('aria-busy', 'true');
      this.btn.disabled = true;
      this.classList.add('is-loading');

      fetch(next, { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('bad status');
          return r.text();
        })
        .then((html) => {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var src = doc.querySelector(this.dataset.target);
          if (!src) throw new Error('no grid');
          var before = target.children.length;
          Array.prototype.slice.call(src.children).forEach(function (li) {
            li.classList.remove('scroll-trigger', 'animate--slide-in', 'animate--fade-in');
            li.removeAttribute('data-cascade');
            target.appendChild(document.importNode(li, true));
          });
          var nextEl = doc.querySelector('load-more[data-target="' + this.dataset.target + '"]');
          var nextUrl = nextEl && nextEl.dataset.next;
          if (nextUrl && src.children.length) {
            this.dataset.next = nextUrl;
          } else {
            this.remove();
          }
          var first = target.children[before];
          var link = first && first.querySelector('a');
          if (link && link.focus) link.focus({ preventScroll: true });
        })
        .catch(() => {
          this.btn.textContent = this.dataset.error || 'Could not load. Tap to retry';
        })
        .then(() => {
          this.busy = false;
          this.removeAttribute('aria-busy');
          this.classList.remove('is-loading');
          if (this.btn) this.btn.disabled = false;
        });
    }
  }
  customElements.define('load-more', LoadMore);
})();
